import React, { Component } from 'react';
import { Button, Icon, Form, Segment } from 'semantic-ui-react';
import ReactTable from 'react-table';
import Dropzone from 'react-dropzone';
import Loading from '../Loading';
import { listAccountDocuments, uploadAccountDocuments, downloadAccountDocuments } from '../../utils/rest';
import { NotificationManager } from 'react-notifications';
class Documents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            availbaleDocuments: [],
            loading: false
        };
    }

    componentDidMount() {
        this.listDocument(this.props.acoAccountId)
    }

    onDrop = (acceptedFiles) => {
        // do stuff with files…
        const data = new FormData()
        acceptedFiles.forEach(file => {
            data.append('files', file);
        });

        this.setState({
            loading: true
        }, () => {
            uploadAccountDocuments(this.props.acoAccountId, data).then((response) => {
                if (response !== null) {
                    NotificationManager.success('Success', 'Document uploaded successfully.');
                    this.listDocument(this.props.acoAccountId);
                }
            })
        }
        );
    }

    listDocument = (acoAccountId) => {
        listAccountDocuments(acoAccountId).then((response) => {
            if (response !== null && response instanceof Array) {
                this.setState({
                    availbaleDocuments: response,
                    loading: false
                })

            }
        })
    }

    downloadDocument = (acoAccountId, documentId) => {
        downloadAccountDocuments(acoAccountId, documentId).then((response) => {
            if (response !== null) {
                let disposition = response.request.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        let filename = matches[1].replace(/['"]/g, '');
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were 
                            // revoked by closing the blob for which they were created. 
                            // These URLs will no longer resolve as the data backing 
                            // the URL has been freed."
                            window.navigator.msSaveBlob(new Blob([response.data]), filename);
                        } else {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                }
            }
        })
    }

    showLoading = () => {
        if (this.state.loading) {
            return (<Loading size="mini" />)
        }
    }


    render() {
        return (
            <div>
                <Segment.Group>
                    <Segment>
                        {this.showLoading()}
                        <Form.Field>
                            <Dropzone style={{
                                position: "relative",
                                height: "50px",
                                borderWidth: "2px",
                                borderColor: "rgb(102, 102, 102)",
                                borderStyle: "dashed",
                                borderRadius: "5px",
                                textAlign: "center"
                            }} onDrop={(files) => this.onDrop(files)}>
                                <br></br>Try dropping some files here, or click to select documents to upload.
                    </Dropzone>
                        </Form.Field>
                    </Segment>
                </Segment.Group>
                <Segment.Group>
                    <Segment>
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSizeMini} showPagination={this.state.availbaleDocuments && this.state.availbaleDocuments.length > this.props.reactTable().pageSizeMini ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.state.availbaleDocuments}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}

                            columns={[
                                {
                                    Header: props => this.props.t("our.account"),
                                    accessor: 'acoAccountId',
                                    width: 100
                                }, {
                                    Header: props => 'Document Name',
                                    accessor: 'documentName',
                                }, {
                                    Header: props => 'Uploaded DateTime',
                                    accessor: 'date',
                                    width: 150
                                }, {
                                    Header: props => <span data-inverted="" data-position="bottom right">{this.props.t("actions")}</span>,
                                    filterable: false,
                                    width: 80,
                                    style: {
                                        textAlign: "center"
                                    },
                                    Cell: row => (
                                        <Button onClick={() => { this.downloadDocument(row.original.acoAccountId, row.original.documentId) }} className="ui icon mini button" data-inverted="" data-tooltip={this.props.t("edit.tooltip")} data-position="top right">
                                            <Icon name="download" />
                                        </Button>
                                    )
                                }]}
                        />
                    </Segment>
                </Segment.Group>
            </div>

        )
    }
}
export default Documents;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/Documents.js